import React from 'react';

import { withAuthorization } from '../Session';
import Layout from '../Page';

const Orders = () => (
  <Layout page={props.page} user={props.user}>
    Orders
  </Layout>
);

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(Orders);
